export const getDialogIcon = (icon) => {
    var iconValue = ""
    switch (icon.toLowerCase()) {
      case "question":
        iconValue = "fas fa-question-circle";
        break;
      case "stop":
      case "error":
        iconValue = "fas fa-times-circle";
        break;
      case "warning":
        iconValue = "fas fa-exclamation-triangle";
        break;
      case "success":
        iconValue = "fas fa-check-circle";
        break;
      case "info":
        iconValue = "fas fa-info-circle";
        break;
      default:
        iconValue = "fas fa-info-circle";
        break;
    }
    return iconValue;
  
  }
  
  export const getAlertType = (alertType) => {
    var alertValue = ""
    switch (alertType.toLowerCase()) {
      case "question":
        alertValue = "alert-example";
        break;
      case "stop":
      case "error":
        alertValue = "alert-error";
        break;
      case "warning":
        alertValue = "alert-warning";
        break;
      case "success":
        alertValue = "alert-success";
        break;
      case "info":
        alertValue = "alert-default";
        break;
      default:
        alertValue = "alert-default";
        break;
    }
    return alertValue;
  }
  